import { attributesToProps, domToReact } from 'html-react-parser';
import EntityLinkTooltip from 'components/EntityLinkTooltip';
import StyledContendHint from 'components/StyledContendHint';
import Icon from 'components/Icon';

export const addTooltipToStyledContent = (domNode) => {
	const { type, name, attribs, children } = domNode;
	if (type === 'tag' && name === 'a' && attribs?.href) {
		const { href } = attribs;
		const props = attributesToProps({ ...attribs });

		return (
			<>
				<a data-tooltip-id={href} {...props}>
					{domToReact(children)}&#65279;
					{/* &#65279; - Zero Width No-Break Space (also known as Byte Order Mark -BOM) */}
				</a>
				<EntityLinkTooltip key={href} id={href} link={href} />
			</>
		);
	}

	if (type === 'tag' && name === 'span' && attribs['data-hint-text']) {
		const hintText = attribs['data-hint-text'];
		const hintImg = attribs['data-hint-img'];

		const props = attributesToProps({ ...attribs });
		return (
			<>
				<span {...props}>
					{domToReact(children)}
					<Icon icon="info-circle" data-tooltip-id={hintText} />
					&#65279;
				</span>
				<StyledContendHint
					key={hintText}
					id={hintText}
					text={hintText}
					imageSrc={hintImg}
				/>
			</>
		);
	}

	return domNode;
};
